import { API } from './resources'

export default {
  getUrl: () => {
    return API.get('/linkedin/auth')
  },

  verify: (code, state) => {
    return API.get('/linkedin/verify', { params: { code, state } })
  },

  getStatus: () => {
    return API.get('/linkedin/status')
  },

  getProfile: () => {
    return API.get('/linkedin/profile')
  }
}
